/*
 * Copyright (c) CIRROM 2022.
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";

export function CirromLogo() {
  const navigate = useNavigate();
  return (
    <div
      style={{ display: "flex", flexDirection: "row", cursor: "pointer" }}
      onClick={() => navigate("/app/dashboard")}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") navigate("/app/dashboard");
      }}
      role={"button"}
      tabIndex={0}
    >
      <img
        alt="Logo"
        src="/Cirrom_Logo_Yellow_Background.svg"
        style={{ width: "160px" }}
      />
    </div>
  );
}

export function CirromLogoContrast() {
  const navigate = useNavigate();
  return (
    <div
      style={{ display: "flex", flexDirection: "row", cursor: "pointer" }}
      onClick={() => navigate("/app/dashboard")}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") navigate("/app/dashboard");
      }}
      role={"button"}
      tabIndex={0}
    >
      <img
        alt="Logo"
        src="/Cirrom_Logo_Yellow_Background_Contrast.svg"
        style={{ width: "160px" }}
      />
    </div>
  );
}

export function CirromLogoMin() {
  const navigate = useNavigate();
  return (
    <div
      style={{
        marginTop: "7px",
        display: "flex",
        flexDirection: "row",
        cursor: "pointer",
      }}
      onClick={() => navigate("/app/dashboard")}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") navigate("/app/dashboard");
      }}
      role={"button"}
      tabIndex={0}
    >
      <img
        alt="Logo"
        src="/Cirrom_Logo_Yellow_C.svg"
        style={{ width: "50px" }}
      />
    </div>
  );
}

export function CirromLogoAvatar(props: { styleOverrides?: any }) {
  return (
    <Avatar
      variant={"square"}
      style={props.styleOverrides || { width: "48px", height: "48px" }}
      alt={"cirrom_logo"}
      src={"/Cirrom_Logo_Yellow_c.svg"}
    />
  );
}
